"use strict";

(function ($) {
  $.fn.sameCheckbox = function () {
    var that = this;
    that.on('click', function () {
      if ($(this).prop('checked') == true) {
        that.prop('checked', true);
      } else {
        that.prop('checked', false);
      }
    });
  };
})(jQuery);

$(function () {
  if ($('.js-same-checkbox').length) {
    $('.js-same-checkbox').sameCheckbox();
  }
});